import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { ingestAlerts, pollingInterval } = formData;
  const handleSubmit = () => {
    if (pollingInterval.value >= 1) {
      setFormError(null);
      onSubmit();
    } else {
      setFormError({
        full_message: t("sophos.subscribe.invalid_polling_interval_message"),
        nice_message: t("sophos.subscribe.min_polling_interval")
      });
    }
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      disabled: !!formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "ingestAlerts",
        type: "checkbox",
        value: "ingest-alerts",
        defaultChecked: ingestAlerts == null ? void 0 : ingestAlerts.value,
        onChange,
        label: t("sophos.subscribe.ingest_alerts"),
        help: t("sophos.subscribe.ingest_alerts_help")
      }
    ),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pollingInterval",
        name: "pollingInterval",
        type: "number",
        value: pollingInterval.value || pollingInterval.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("sophos.subscribe.polling_interval_help"),
        label: t("common.fields.polling_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
